export const Style = {
  MuiTableCellRoot: {
    fontSize: '13px',
    fontWeight: 700,
    padding: '5px 10px',
    lineHeight: '20px',
    color: 'white',
  },
  borderInherit: {
    borderCollapse: 'inherit',
  },
  MuiButtonBaseRoot: {
    color: 'white !important',
  },
  MuiTableCellRootTd: {
    fontSize: '13px',
    padding: '5px 15px',
    lineHeight: '20px',
    borderBottom: 'unset',
  },
  sticky1: {
    position: 'sticky',
    left: 0,
    background: 'white',
    zIndex: 5,
  },
  sticky2: {
    position: 'sticky',
    left: 47.2,
    background: 'white',
    zIndex: 5,
  },
  sticky3: {
    position: 'sticky',
    left: 296.5,
    background: 'white',
    zIndex: 5,
    color: '#0284c7',
  },

  '.MuiOutlinedInput-root': {
    padding: 0,
  },
  'Mui-disabled': {
    background: 'white',
  },
  '.MuiOutlinedInput-input': {
    fontSize: '13px',
    background: 'white!important',
  },
  '.MuiOutlinedInput-notchedOutline': { borderRadius: 0 },
};
